import r from "path-to-regexp";

var t = function t(r) {
  return function (t, e, n) {
    return {
      type: r,
      payload: {
        code: t,
        params: {
          path: e,
          query: n
        }
      }
    };
  };
},
    e = {
  push: t("@@router/PUSH"),
  replace: t("@@router/REPLACE"),
  goBack: function goBack(r) {
    return void 0 === r && (r = 1), {
      type: "@@router/GO_BACK",
      payload: r
    };
  },
  goForward: function goForward(r) {
    return void 0 === r && (r = 1), {
      type: "@@router/GO_FORWARD",
      payload: r
    };
  }
},
    n = "@@router/ROUTE_FOUND",
    o = Object.assign(function (r) {
  return {
    type: n,
    payload: Object.assign({
      found: !0
    }, r)
  };
}, {
  type: n
}),
    u = function u(r) {
  var t = function t(_t) {
    return r(_t).result;
  },
      e = function e(r) {
    return t(r).route;
  },
      n = function n(r) {
    return function (t) {
      return e(t)[r];
    };
  },
      o = function o(r) {
    return t(r).params;
  },
      u = function u(r) {
    return o(r).path;
  },
      a = function a(r) {
    return o(r).query;
  },
      i = function i(r) {
    return function (t) {
      var e = u(t);
      if (e) return e[r];
    };
  },
      c = function c(r) {
    return function (t) {
      if (a(t)) return a(t)[r];
    };
  };

  return {
    getState: r,
    getRoute: function getRoute(t) {
      return function (e) {
        return r(e).routes.map[t];
      };
    },
    getResult: t,
    getCurrentCode: function getCurrentCode(r) {
      return e(r).code;
    },
    getCurrentRoute: e,
    isFound: function isFound(r) {
      return t(r).found;
    },
    getResultParam: n,
    getParams: o,
    getPathParams: u,
    getQueryParams: a,
    getPathParam: i,
    getQueryParam: c,
    getParam: function getParam(r) {
      return function (t) {
        return n(r)(t) || i(r)(t) || c(r)(t);
      };
    }
  };
},
    a = function a() {
  return {
    type: "@@router/INIT"
  };
},
    i = function i(r) {
  return !("object" != typeof r || !r.code);
},
    c = {
  history: window && window.history,
  location: window && window.location
},
    f = function f(t, n) {
  void 0 === n && (n = c);
  var f = Object.assign({}, c, n);
  if (!f.history) throw new Error("[k-redux-router] no history implementation is given");
  if (!f.location) throw new Error("[k-redux-router] no location implementation is given");
  var s = {
    array: function (t) {
      var e = [],
          n = function n(t, o, u) {
        var a = {};
        o && (a = Object.entries(o).filter(function (r) {
          return !i(r[1]);
        }).reduce(function (r, t) {
          var e;
          return Object.assign(r, ((e = {})[t[0]] = t[1], e));
        }, {}));
        var c = u;
        o && (c = Object.assign(a, u, {
          parent: o && o.code,
          href: {
            base: t,
            compiled: t.includes(":") ? r.compile(t) : void 0,
            regexp: r(t),
            parsed: r.parse(t)
          }
        }), e.push(c)), Object.entries(u).filter(function (r) {
          return i(r[1]);
        }).forEach(function (r) {
          var e = r[1];
          return n([t, r[0]].join("").replace("//", "/"), c, e);
        });
      };

      return n("", void 0, t), e.forEach(function (r) {
        Object.entries(r).forEach(function (t) {
          var e = t[0],
              n = t[1],
              o = n;
          i(n) && (o = n.code), r[e] = o;
        });
      }), e;
    }(t)
  };
  s.map = s.array.reduce(function (r, t) {
    var e;
    return Object.assign({}, r, ((e = {})[t.code] = t, e));
  }, {});

  var p = function (r, t) {
    void 0 === t && (t = {});

    var n = Object.assign({}, {
      routes: s,
      result: {
        found: !1
      }
    }),
        o = function o(r, t) {
      void 0 === r && (r = n), void 0 === t && (t = {});
      var e = t.payload;

      switch (t.type) {
        case "@@router/ROUTE_FOUND":
          return Object.assign({}, r, {
            result: e
          });

        default:
          return r;
      }
    };

    return Object.assign(o, u(t.getState || function (r) {
      return r.ui.router;
    })), Object.assign(o, e), o;
  }(0, f);

  return {
    middleware: function (r, t, e) {
      var n = !1,
          u = function (r, t) {
        return function (e) {
          var n = r.location;

          if (n.pathname) {
            var u,
                a = t.getState(e.getState()).routes.array.find(function (r) {
              return !!(u = r.href.regexp.exec(n.pathname));
            });
            if (!a) return;
            u = a.href.parsed.map(function (r) {
              return r.name;
            }).filter(Boolean).reduce(function (r, t, e) {
              var n;
              return Object.assign(((n = {})[t] = u[e + 1], n), r);
            }, {}), e.dispatch(o({
              route: a,
              params: {
                path: u,
                query: function (r) {
                  if (r.search.length < 2) return {};
                  var t = r.search.substring(1);
                  return JSON.parse('{"' + decodeURI(t).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
                }(n)
              }
            }));
          }
        };
      }(t, e),
          a = function (r, t) {
        var e = r.history;
        return function (r) {
          return function (n) {
            var u,
                a = n.type,
                i = n.payload;

            switch (a) {
              case "@@router/GO_FORWARD":
                return void e.go(i);

              case "@@router/GO_BACK":
                return void e.go(-1 * i);

              case "@@router/REPLACE":
              case "@@router/PUSH":
                var c = i.code,
                    f = i.params;
                void 0 === f && (f = {});
                var s = t.getState(r.getState()).routes.map[c];

                if (s) {
                  var p = s.href,
                      d = {};
                  f && f.path && p.parsed && p.parsed.filter(function (r) {
                    return "object" == typeof r;
                  }).map(function (r) {
                    return r.name;
                  }).filter(function (r) {
                    return f.path[r];
                  }).forEach(function (r) {
                    d[r] = f.path[r];
                  });
                  var v = "",
                      l = p.base;
                  p.compiled && (l = p.compiled(d)), f.query && (v = "?" + (u = f.query, Object.keys(u).map(function (r) {
                    return encodeURIComponent(r) + "=" + encodeURIComponent(u[r]);
                  }).join("&"))), l = "" + l + v, "@@router/PUSH" === a ? e.pushState(void 0, void 0, l) : e.replaceState(void 0, void 0, l);
                  var g = Object.assign({}, f);
                  return f && f.path && (g.path = d), o({
                    route: s,
                    params: g
                  });
                }

                return;

              default:
                return;
            }
          };
        };
      }(t, e);

      return function (r) {
        return function (t) {
          return function (e) {
            if (!e.type || !e.type.startsWith("@@router/")) return t(e);
            var i = t(e);
            "@@router/INIT" === e.type && (u(r), n ? console.warn("[k-redux-router] initialized twice") : (n = !0, window && (window.onpopstate = function () {
              u(r);
            }))), n || e.type === o.type || console.warn("[k-redux-router] router should be initialized");
            var c = a(r)(e);
            return c && r.dispatch(c), i;
          };
        };
      };
    }(0, f, p),
    reducer: p,
    init: a
  };
};

export { e as actions, f as router, u as selectors };